import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '~components/ui/select';

type DrilledHolePropertySelectProps = {
  /** Currently selected drilled hole property, e.g., 'hardness_value', 'depth_actual' */
  selectedHoleProperty: string;
  /** Callback when hole property changes */
  onHolePropertyChange: (property: string) => void;
};

/**
 * Dropdown selector for choosing a drilled hole property to colour by
 */
const DrilledHolePropertySelect = ({ selectedHoleProperty, onHolePropertyChange }: DrilledHolePropertySelectProps) => {
  return (
    <>
      <h3 className="font-bold text-foreground text-lg">Colour Drill Holes By</h3>
      <Select value={selectedHoleProperty} onValueChange={onHolePropertyChange}>
        <SelectTrigger className="w-full text-sm">
          <SelectValue placeholder="Select a parameter" />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="hardness">Hardness</SelectItem>
          <SelectItem value="hardness_planned">Hardness (Planned)</SelectItem>
          <SelectItem value="depth_actual">Depth Actual</SelectItem>
          <SelectItem value="bearing_actual">Bearing Actual</SelectItem>
          <SelectItem value="dip_actual">Dip Actual</SelectItem>
          <SelectItem value="hazardous_value">Hazardous Value</SelectItem>
          <SelectItem value="mwd_value">MWD Value</SelectItem>
          <SelectItem value="drill_domain_id">Drill Domain</SelectItem>
          <SelectItem value="blast_domain_id">Blast Domain</SelectItem>
        </SelectContent>
      </Select>
    </>
  );
};

export { DrilledHolePropertySelect };
